import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=37d00bfd&scoped=true"
import script from "./Currencies.vue?vue&type=script&lang=js"
export * from "./Currencies.vue?vue&type=script&lang=js"
import style0 from "./Currencies.vue?vue&type=style&index=0&id=37d00bfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d00bfd",
  null
  
)

export default component.exports